import type { BlogQuery, WPCategoryResponse, BlogPostContext } from '~/server/type'
import type { IRequestResponse } from '~/types'
import { resolve } from '~/utils/functions'

export const useBlogApi = () => {
	const getAllPost = async (query?: Partial<BlogQuery>) => {
		const { data } = await $fetch<IRequestResponse<PaginationContext<BlogPostContext>>>('/api/bff/v1/blogs/posts', {
			query,
			cache: 'no-cache'
		})
		return data
	}
	const getPostById = async (id: number | string, query?: Partial<BlogQuery>) => {
		const result = await resolve<IRequestResponse<BlogPostContext>>(
			async () =>
				await $fetch(`/api/bff/v1/blogs/posts/${id}`, {
					query,
					cache: 'reload'
				})
		)
		return result
	}

	const getPostCategories = async (query?: Partial<BlogQuery>) => {
		const { data } = await $fetch<IRequestResponse<WPCategoryResponse>>(`/api/bff/v1/blogs/posts/categories`, {
			query,
			cache: 'no-cache'
		})
		return data
	}
	const getPostBySlug = async (slug: string, query?: Partial<BlogQuery>) => {
		const result = await $fetch<BlogPostContext>(`/api/bff/v1/blogs/posts/${slug}`, {
			query,
			cache: 'reload'
		})
		return result
	}
	const getRecentPost = async (query?: Partial<IRequestResponse<BlogPostContext[]>>) => {
		const result = await $fetch<PaginationContext<BlogPostContext>>(`/api/bff/v1/blogs/posts/recent`, {
			query
		})
		return result
	}
	const getRelatedPost = async (query?: Partial<IRequestResponse<BlogPostContext[]>>) => {
		const result = await $fetch<PaginationContext<BlogPostContext>>(`/api/bff/v1/blogs/posts/related`, {
			query
		})
		return result
	}
	return {
		getAllPost,
		getPostById,
		getPostCategories,
		getPostBySlug,
		getRecentPost,
		getRelatedPost
	}
}
